import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface issueState {
    id: number,
    issue: string,
    key: string,
    dueDate: string,
    priority: string,
    prioritisationPoints: string,
    createdAt: string,
    updatedAt: string,
    description: string,
    projectLink: string
    workPackagesLink : string
    taskTitle: string
    projectTitle: string
    task_project_commonFieldForSpentTime: string,
    issueData:any,
    issueType: string,
    createdBy: string
    descriptionHTML?: string;
}

export const initialState: issueState = {
    id: 0,
    issue: '',
    key: '',
    dueDate: '',
    priority: '',
    prioritisationPoints:'',
    createdAt: '',
    updatedAt: '',
    description: '',
    projectLink: '',   
    workPackagesLink: '',
    taskTitle: '',
    projectTitle: '',
    task_project_commonFieldForSpentTime: '',
    issueData:{},
    issueType: '',
    createdBy: ''
}

export const issueSlice = createSlice({
    name: 'issue',
    initialState,
    reducers: {
        setStateIssue: (state, action: PayloadAction<issueState>) => {
            state.id = action.payload?.id
            state.issue = action.payload?.issue
            state.key = action.payload?.key
            state.dueDate = action.payload?.dueDate
            state.priority = action.payload?.priority || ''
            state.prioritisationPoints= action.payload?.prioritisationPoints || '-'
            state.createdAt = action.payload?.createdAt
            state.updatedAt = action.payload?.updatedAt
            state.description = action.payload?.description
            state.descriptionHTML = action.payload?.descriptionHTML
            state.projectLink = action.payload?.projectLink
            state.projectLink = action.payload?.projectLink
            state.workPackagesLink = action.payload?.workPackagesLink
            state.taskTitle = action.payload?.taskTitle
            state.projectTitle= action.payload?.projectTitle
            state.task_project_commonFieldForSpentTime = action.payload?.task_project_commonFieldForSpentTime
            state.issueData = action.payload?.issueData
            state.issueType = action.payload?.issueType
            state.createdBy = action.payload?.createdBy
        },
        clearStateIssue: (state) => {
            state.id = 0;
            state.issue = '';
            state.key = '';
            state.dueDate = '';
            state.priority = '';
            state.prioritisationPoints = '';
            state.createdAt = '';
            state.updatedAt = '';
            state.description = '';
            state.projectLink = ''
            state.workPackagesLink = ''
            state.taskTitle = ''
            state.projectTitle = ''
            state.task_project_commonFieldForSpentTime = ''
            state.issueData = {}
            state.issueType = ''
            state.createdBy = ''
        },
        setNewComments: (state, action: PayloadAction<any>) => {
            state.issueData = {
                ...state.issueData,
                ...action.payload
            };
        },
        setModifiedDescription: (state, action: PayloadAction<any>) => {
            state = {
                ...state,
                description: action.payload
            }
        }
    }
});

export const { setStateIssue, clearStateIssue, setNewComments, setModifiedDescription } = issueSlice.actions;

export default issueSlice.reducer;